import { Role } from '@/constants/role.js'
const meta = { authorize: [Role.user] }

export default [
    {
        path: '/project/:projectUuid/translations',
        name: 'project-translations',
        meta,
        component: () => import('@pages2/p-translation'),
    },
    {
        path: '/project/:projectUuid/resources',
        name: 'project-resources',
        meta,
        component: () => import('@pages2/p-resource'),
    },
    {
        path: '/project/:projectUuid',
        name: 'project-main',
        meta,
        component: () => import('@pages2/p-project'),
    },
    {
        path: '/project/:projectUuid/notifs',
        name: 'project-notifs',
        meta,
        component: () => import('@pages2/p-notif'),
    },
]
